module.exports = __webpack_public_path__ + "img/partner.b09ac141.png";